import { Button } from '@southfields-digital/mxmz-react-ui';
import { useDispatch } from 'react-redux';

import {
  REQUEST_UPDATE_LIVE_GRAPHIC,
  REQUEST_UPDATE_PREVIEW_GRAPHIC,
} from 'src/redux/reducers/control';

interface IUpdateGraphicButtonProps {
  selectedGraphic: PlaylistGraphic;
  target: 'live' | 'preview';
  isPropertiesDirty: boolean;
  onUpdate: () => void;
}

export default function UpdateGraphicButton({
  selectedGraphic,
  target,
  isPropertiesDirty,
  onUpdate,
}: IUpdateGraphicButtonProps) {
  const dispatch = useDispatch();

  const handleUpdate = () => {
    dispatch({
      type: target === 'live' ? REQUEST_UPDATE_LIVE_GRAPHIC : REQUEST_UPDATE_PREVIEW_GRAPHIC,
      payload: { playlistGraphicId: selectedGraphic.id, payload: 'data:update' },
    });
    onUpdate();
  };

  return (
    <Button
      as="button"
      buttonSize="small"
      variant="muted"
      onClick={handleUpdate}
      disabled={!isPropertiesDirty || !selectedGraphic.status[target]}
      className="!outline-none !ring-0"
      iconProps={{
        icon: 'check',
        size: 16,
        weight: 'bold',
      }}
    >
      {target === 'live' ? 'Update PGM' : 'Update PVW'}
    </Button>
  );
}
